import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { valueStories } from '@/data/sponsor/sponsorshipTiers';
import { ChartBarIcon, UserGroupIcon, BoltIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';

const icons = {
  "Meaningful Differentiation": ChartBarIcon,
  "Stronger Relationships": UserGroupIcon,
  "Low Operational Lift": BoltIcon,
  "Clear Value to the People You Serve": CurrencyDollarIcon
};

const ValueStorySection = () => {
  return (
    <div className="py-16 bg-muted/20">
      <div className="container mx-auto px-4">
        {/* Client Conversation Framework */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
            Why Bring SeniorThrive to the People You Serve?
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            A practical way to support independence while strengthening long-term relationships.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {valueStories.map((story, index) => {
            const IconComponent = icons[story.title as keyof typeof icons];
            return (
              <Card key={index} className="border-border/50 hover:border-primary/20 transition-all duration-300 h-full">
                <CardHeader className="text-center pb-4">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-bold text-foreground">{story.title}</CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <CardDescription className="text-center">{story.description}</CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ValueStorySection;
